// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__w9iAy","expandIcon":"AccordionButton_expandIcon__31P1i","expanded":"AccordionButton_expanded__oCfsT"};